import React from "react";
import { Footer } from "./sections/Footer";
import { Header } from "./sections/Header";
import { Middle } from "./sections/Middle";
import "./style.css";

export const BusinessLearnMore = () => {
  return (
    <div className="business-learn-more">
      <div className="div-2">
        <div className="overlap-14">
          <div className="layer" />

          <Footer />
          <Middle />
          <div className="banner">
            <div className="overlap-15">
              <div className="text">
                <div className="business-wrapper">
                  <div className="business">BUSINESS</div>
                </div>
              </div>
            </div>

            <div className="img-3">
              <div className="overlap-group-8">
                <div className="ellipse-12" />

                <img className="image-4" alt="Image" src="/img/image-1-9.png" />
              </div>
            </div>
          </div>
        </div>

        <Header />
      </div>
    </div>
  );
};


export default BusinessLearnMore;